import axios from "axios";
import { Media } from "@models/Media";

// Keep the tribute credential separate from any signed-in account credentials.
const client = axios.create({ baseURL: process.env.REACT_APP_CLOUD_API_BASE_URL });
const path = "/memorial/tribute/manage";
export interface ManagedTribute { name: string; message: string; media?: Media; memorialUrl: string; }
const config = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function fetchManagedTribute(token: string): Promise<ManagedTribute> {
    return (await client.get<ManagedTribute>(path, config(token))).data;
}

export async function deleteManagedTribute(token: string) {
    await client.delete(path, config(token));
}
